<template>
  <b-modal ref="modal" centered class="text-left" @ok="$emit('editRoles', user, selectedRoles)">
    <div slot="modal-title">
      {{ this.user.Username }} - Edit roles
    </div>
    <b-form-group>
      <b-form-checkbox-group stacked v-model="selectedRoles" :options="roles">
      </b-form-checkbox-group>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  props: {
    roles: Array
  },
  data() {
    return {
      user:          {},
      selectedRoles: []
    };
  },
  methods: {
    showModal(user, selected) {
      this.user          = user;
      this.selectedRoles = selected;
      this.$refs.modal.show();
    }
  }
};
</script>
